import { render } from "./Mapfake2.vue?vue&type=template&id=0a8d4116&bindings={}"
import script from "./Mapfake2.vue?vue&type=script&lang=js"
export * from "./Mapfake2.vue?vue&type=script&lang=js"

import "./Mapfake2.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script